import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {SurveryEvaluationService} from '../survey-thirtyeighty/survery-evaluation.service';
import {LoadingService} from '../../services/loading/loading.service';
import { AdminThirtyEightyService } from '../admin-thirty-eighty-services/admin-thirty-eighty-service.service';
import { AlertService } from '../../services/alert/alert.service';

@Component({
    selector: 'app-admin-survey-thirtyeighty',
    templateUrl: './admin-survey-thirtyeighty.component.html',
    styleUrls: ['./admin-survey-thirtyeighty.component.css'],
    standalone: false
})
export class AdminSurveyThirtyeightyComponent implements OnInit {
  radioTitle: string;
  radioItems: Array<string>;
  model   = {option: ''};
  surveyNo: any;
  lastNameEmployee: string;

  constructor(private router: Router,
              private surveyService: SurveryEvaluationService,
              private loader: LoadingService,
              private adminThirtyEightyService: AdminThirtyEightyService,
              private alertService: AlertService) {
    this.radioTitle = 'Radio Button in Angular';
    this.radioItems = ['Survey Number', 'BOL Number'];
  }

  ngOnInit() {
  }
  modifySurvey() {
    if (this.model.option === 'Survey Number') {
      this.router.navigate(['/evaluationForm'],  { queryParams: { adminSurveyNo: this.surveyNo } });
    } else if (this.model.option === 'BOL Number') {
      this.router.navigate(['/evaluationForm'],  { queryParams: { adminBol: this.surveyNo } });
    }
  }

  seachByEmpLastName(){
    this.loader.show();
    this.surveyService.isExistingSurvey(this.lastNameEmployee).subscribe(res => {
      this.loader.hide();
      if(res === false){
        this.alertService.error('Invalid Last Name');
      }else{
        this.adminThirtyEightyService.setEmplLastName(this.lastNameEmployee);
        this.router.navigate(['/adminEmployeeThirtyEighty']);
      }
    }, error => {
      this.loader.hide();
      this.alertService.error('There was an error retrieving Employee Last Name from Survey');
      console.log(error);
    });
  }

}
